import React, { useEffect, useRef, useState } from 'react';

import { Wrapper } from '@googlemaps/react-wrapper';
import { Modal } from 'react-bootstrap';
import Map from './Map';
import Marker from './Marker';

const MapaRender = ({ show, onClose, legend = 'Elije la ubicacion', marks, setCoor, vi = false }) => {
    const [markers, setMarkers] = useState(marks);
    const [mapZoom, setMapZoom] = useState(10);
    const [cen, setCen] = useState({
        lat: 19.89412842358178,
        lng: -100.45932325488768,
    });
    useEffect(() => {
        if (marks.length > 0) {
            setMarkers(marks);
        }
    }, [marks]);
    const mapRef = useRef(null);

    const onClick = (e) => {
        if (vi) return;
        let arr = JSON.stringify(e.latLng.toJSON(), null, 2);
        arr = JSON.parse(arr);
        const { lat, lng } = arr;
        if (lat && lng) {
            setMarkers([{ lat, lng }]);
            if (typeof lat === 'number' && typeof lng === 'number' && isFinite(lat) && isFinite(lng)) {
                const center = new window.google.maps.LatLng(lat, lng);
                setCen(center);
            }
            setCoor(`${lat},${lng}`);
        }
    };
    const funClose = () => {
        onClose();
    };
    const onIdle = (m) => {
        const mapCenter = m.getCenter();
        const lat = mapCenter.lat();
        const lng = mapCenter.lng();
        setCen({ lat, lng });
        setMapZoom(m.getZoom());
    };
    return (
        <Modal show={show} onClose={funClose}>
            <Modal.Header onHide={funClose} closeButton>
                <h5>{legend}</h5>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: 'flex', height: '500px' }}>
                    <Wrapper apiKey={'AIzaSyDYwOswnMRBD_yx_rRIOPycMVsbeaO6Ra8'} style={{ position: 'relative' }}>
                        <Map
                            center={cen}
                            zoom={mapZoom}
                            style={{ width: '100%', height: '100%' }}
                            onClick={onClick}
                            onIdle={onIdle}
                            // ref={mapRef}
                        >
                            {markers.map((marker, i) => {
                                return <Marker position={marker} key={`${i}map`} legend={legend} />;
                            })}
                        </Map>
                    </Wrapper>{' '}
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default MapaRender;
